// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { RaceEventTitleLocalizationsLayout } from './RaceEventTitleLocalizationsLayout';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  list: [
    {
      id: '94625dfa-d7aa-460e-a50b-b7707b58a2ba',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'abbebc2e-1c2b-4688-8544-7d5270e84056',
      type: 'Sprite',
      name: 'gradient',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: '94625dfa-d7aa-460e-a50b-b7707b58a2ba'
    },
    {
      id: 'eafedfd3-7302-47e6-a1da-0a86503a00b5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 1,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Background_Left_Part',
      parent: '94625dfa-d7aa-460e-a50b-b7707b58a2ba'
    },
    {
      id: '6f913c60-d8cc-403c-8934-1b97d6a8f1b5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Background_Right_Part',
      parent: '94625dfa-d7aa-460e-a50b-b7707b58a2ba'
    },
    {
      id: 'a56cfe23-5458-4f59-873d-8b471e65f46d',
      type: 'Container',
      name: 'contentWrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '94625dfa-d7aa-460e-a50b-b7707b58a2ba'
    },
    {
      id: '9a9f5de6-0525-4ed0-a365-bf4f01c1cea5',
      type: 'Container',
      name: 'titleWrapper',
      className: '',
      x: 0,
      y: 120,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a56cfe23-5458-4f59-873d-8b471e65f46d',
      data: {
        small: {
          y: 49,
          scaleXY: 0.67
        },
        big: {
          y: 109,
          scaleXY: 1
        }
      }
    },
    {
      id: 'e7eb53e0-74e9-4884-975d-6f5eb592c509',
      type: 'Container',
      name: 'popupContainer',
      className: '',
      x: 0,
      y: 552,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a56cfe23-5458-4f59-873d-8b471e65f46d'
    },
    {
      id: '7b24a0e8-8ebb-49a2-ac9a-cfbc2d47a2b6',
      type: 'Container',
      name: 'buttonContainer',
      className: '',
      x: 0,
      y: 1061,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'a56cfe23-5458-4f59-873d-8b471e65f46d'
    },
    {
      id: '8c2739cb-1c2c-4fb1-b71e-afec966b1d07',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Event_Title_Back_Glow',
      parent: '9a9f5de6-0525-4ed0-a365-bf4f01c1cea5'
    },
    {
      id: '4efe1c2a-5958-415a-95dc-5d1775c88f31',
      type: 'Layout',
      name: '',
      className: '',
      path: 'raceEvent/RaceEventTitleLocalizationsLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -19,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '9a9f5de6-0525-4ed0-a365-bf4f01c1cea5'
    },
    {
      id: '0d7484d4-4d6c-4876-8eae-e5cbba48a28c',
      type: 'Container',
      name: 'shareContainer',
      className: '',
      x: -271,
      y: -289,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e7eb53e0-74e9-4884-975d-6f5eb592c509'
    },
    {
      id: 'a8c226b3-68d5-4489-a7d2-aded55641157',
      type: 'Sprite',
      name: '',
      className: '',
      x: 18,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Share_Diorama_Pop_Up',
      parent: 'e7eb53e0-74e9-4884-975d-6f5eb592c509'
    },
    {
      id: 'e07ff6b8-d58d-4623-ae10-27a3310655db',
      type: 'Text',
      name: 'closeButton',
      className: '',
      x: 0,
      y: 107,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -1000,
        y: -2000,
        width: 2000,
        height: 4000
      },
      text: 'Tap to continue',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '7b24a0e8-8ebb-49a2-ac9a-cfbc2d47a2b6'
    },
    {
      id: '803f80d4-89f3-4ead-ad6e-efa33a8395b3',
      type: 'Layout',
      name: 'shareButton',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      parent: '7b24a0e8-8ebb-49a2-ac9a-cfbc2d47a2b6',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '81db0d90-7232-4b16-a452-b1fc922c5b1b',
      type: 'Sprite',
      name: '',
      className: 'userAvatar_SPL',
      x: 241,
      y: 110,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.8,
        y: 2.8
      },
      angle: 15.1,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: '0d7484d4-4d6c-4876-8eae-e5cbba48a28c'
    },
    {
      id: 'b7fdf3df-33ea-4201-b142-db557de1e47c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Share_Image',
      parent: '0d7484d4-4d6c-4876-8eae-e5cbba48a28c'
    },
    {
      id: '4a654be9-32ad-43c2-8857-61c797217fcd',
      type: 'Text',
      name: 'progressText',
      className: '',
      x: 29,
      y: 491,
      anchor: {
        x: 0,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: -15.3,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '#2',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 130,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x172540',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '0x172540',
        dropShadowDistance: 7,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0d7484d4-4d6c-4876-8eae-e5cbba48a28c'
    },
    {
      id: 'fff9cdeb-a6b4-4eb5-94f5-f256a5c22703',
      type: 'Sprite',
      name: '',
      className: 'center_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Facebook_Icon',
      parent: '803f80d4-89f3-4ead-ad6e-efa33a8395b3'
    },
    {
      id: 'a802da3e-6146-42ab-baef-42892435aa59',
      type: 'Text',
      name: '',
      className: 'center_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Share',
      localize: true,
      maxWidth: 232,
      maxHeight: 91,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '0x0047af',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '803f80d4-89f3-4ead-ad6e-efa33a8395b3'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 1280,
  version: '2.0.0',
  handleResize: false
} as const;

export class RaceEventSharePopupLayout {
  static raw = raw;
  root!: Container;
  gradient!: Sprite;
  contentWrapper!: Container;
  titleWrapper!: Container & { data: typeof raw['list'][5]['data'] };
  popupContainer!: Container;
  buttonContainer!: Container;
  shareContainer!: Container;
  closeButton!: Text;
  shareButton!: ButtonLargeLayout & { data: typeof raw['list'][13]['data'] };
  progressText!: Text;
  userAvatar_SPL!: (Sprite)[];
  center_SPL!: (Sprite | Text)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
